import "./ProgressDots.scss";
import { PROGRESS_DOTS_TOTAL } from "../../constants";

const ProgressDots = ({ active }) => {
  return (
    <div className="progress__dots">
      {Array.from({ length: PROGRESS_DOTS_TOTAL }).map((_, index) => (
        <span
          key={index}
          className={index < active ? "active" : ""}
        ></span>
      ))}
    </div>
  );
};

export default ProgressDots;
